import {
  Search,
  User,
  Calendar,
  Settings,
  Home,
  Award,
  BadgeCheck,
  BookCheck,
  BookOpen,
  Briefcase,
  BriefcaseBusiness,
  Building,
  Building2,
  Car,
  ChartColumnIncreasing,
  ChartLine,
  ChartScatter,
  CircleArrowOutUpRight,
  CircleCheckBig,
  Clock4,
  Cog,
  Command,
  Cpu,
  Database,
  FileTerminal,
  Goal,
  GraduationCap,
  Grid2x2,
  HandCoins,
  HandHelping,
  Headset,
  Hospital,
  Infinity,
  Landmark,
  Languages,
  Laptop,
  Lightbulb,
  Mail,
  Maximize2,
  MonitorCog,
  NotepadText,
  Phone,
  PhoneIncoming,
  RefreshCcw,
  Rocket,
  Route,
  Scaling,
  ShieldCheck,
  SquareCheckBig,
  Store,
  TrendingUp,
  TriangleAlert,
  Trophy,
  Truck,
  ThumbsUp,
  UserCheck,
  UserRoundCheck,
  Users,
  Wallet,
  Zap,
  type LucideIcon,
  Globe,
  ArrowLeftRight,
  UserCog,
  Sparkles,
} from "lucide-react";

export const iconMap = {
  award: Award,
  "arrow-left-right": ArrowLeftRight,
  "badge-check": BadgeCheck,
  "book-check": BookCheck,
  "book-open": BookOpen,
  briefcase: Briefcase,
  "briefcase-business": BriefcaseBusiness,
  building: Building,
  "building-2": Building2,
  car: Car,
  "chart-column-increasing": ChartColumnIncreasing,
  "chart-line": ChartLine,
  "chart-scatter": ChartScatter,
  "circle-arrow-out-up-right": CircleArrowOutUpRight,
  "circle-check-big": CircleCheckBig,
  "clock-4": Clock4,
  cog: Cog,
  command: Command,
  cpu: Cpu,
  database: Database,
  "file-terminal": FileTerminal,
  goal: Goal,
  "graduation-cap": GraduationCap,
  "grid-2x2": Grid2x2,
  "hand-coins": HandCoins,
  "hand-helping": HandHelping,
  headset: Headset,
  hospital: Hospital,
  infinity: Infinity,
  landmark: Landmark,
  languages: Languages,
  laptop: Laptop,
  lightbulb: Lightbulb,
  mail: Mail,
  "maximize-2": Maximize2,
  "monitor-cog": MonitorCog,
  "notepad-text": NotepadText,
  phone: Phone,
  "phone-incoming": PhoneIncoming,
  "refresh-ccw": RefreshCcw,
  rocket: Rocket,
  route: Route,
  scaling: Scaling,
  "shield-check": ShieldCheck,
  "square-check-big": SquareCheckBig,
  store: Store,
  "thumbs-up": ThumbsUp,
  "trending-up": TrendingUp,
  "triangle-alert": TriangleAlert,
  trophy: Trophy,
  truck: Truck,
  "user-check": UserCheck,
  "user-round-check": UserRoundCheck,
  users: Users,
  wallet: Wallet,
  zap: Zap,
  search: Search,
  user: User,
  calendar: Calendar,
  settings: Settings,
  home: Home,
  globe: Globe,
  "user-cog": UserCog,
  sparkles: Sparkles,
} satisfies Record<string, LucideIcon>;

export type IconName = keyof typeof iconMap;
